export default class ColorModel {
    ColorId: number;
    ColorName: string;
    ColorCode: string;
    Description: string;
}
